/**
 * @file 契約プラン情報を管理するステート
 *
 * 契約プランAPIから取得した、現在の料金プラン・契約ステータス・
 * サービス開始日・契約期間等の情報を保持する。
 * トップページのプラン情報セクションや、
 * 回線開通状態の判定（userStateでのisOpen）に使用される。
 * セッションストレージに永続化される。
 */
import { atom } from 'recoil';
import { PlanType, ServiceType, CnStatusCode } from '@/types/api/mypage/planInfo';
import persistAtom from './recoilPersist';

export type PlanInfoStateType = {
  planCode: string; // 料金プランコード
  planName: string; // 料金プラン名称
  cnStatusCode?: CnStatusCode; // 契約ステータス
  cnStatusName: string; // 契約ステータス名称
  planType?: PlanType; // プラン種別
  serviceType?: ServiceType; // サービス種別
  serviceStartDate?: string; // サービス開始日
  acceptDate: string; // 受付日
  contractTotalMonth: number; // 契約期間（ヶ月）
  preferredQuitDate: string; // 解約希望日
  canEntryCancel: boolean; // 申込可否
  canQuitCancel: boolean; // キャンセル可否
};

export const planInfoState = atom<PlanInfoStateType>({
  key: 'planInfoState',
  default: {
    planCode: '',
    planName: '',
    cnStatusCode: undefined,
    cnStatusName: '',
    planType: undefined,
    serviceType: undefined,
    serviceStartDate: undefined,
    acceptDate: '',
    contractTotalMonth: 0,
    preferredQuitDate: '',
    canEntryCancel: false,
    canQuitCancel: false,
  },
  effects_UNSTABLE: [persistAtom],
});

export default planInfoState;
